export default __webpack_public_path__ + "static/media/carpark.526fbf1b.png";